<div class="wrapper">
  <div class="body">
    <h1>¡Bienvenido!</h1>

    <img class="logo" src="assets/camben-logo-oficial.png" alt="logo" />
    <br />
    <br />

    <div *ngIf="message" class="alert-container">
      <div [ngClass]="{'alert-success': !error, 'alert-danger': error}">
        {{ message }}
      </div>
    </div>
    
    <div *ngIf="!showForgotPassword">
      <form [formGroup]="contactForm">
        <p>
          <mat-form-field
            appearance="outline"
            class="controles-container botonfull"
          >
            <mat-label>Correo</mat-label>
            <input
              matInput
              type="text"
              placeholder="Ingresa tu correo"
              formControlName="email"
            />
          </mat-form-field>
        </p>
        <p>
          <mat-form-field
            appearance="outline"
            class="controles-container botonfull"
          >
            <mat-label>Contraseña</mat-label>
            <input
              matInput
              [type]="hide ? 'password' : 'text'"
              placeholder="Ingresa tu contraseña"
              formControlName="password"
            />
            <span
              mat-icon-button
              matSuffix
              (click)="hide = !hide"
              [attr.aria-label]="'Hide password'"
              [attr.aria-pressed]="hide"
            >
            <mat-icon color="accent">{{
              hide ? "visibility_off" : "visibility"
            }}</mat-icon>
          </span>
          </mat-form-field>
        </p>
        <p>
          <mat-form-field
            appearance="outline"
            class="controles-container botonfull"
          >
            <mat-label>Teléfono</mat-label>
            <input
              matInput
              type="tel"
              placeholder="Ingresa tu teléfono"
              formControlName="phone"
            />
          </mat-form-field>
        </p>
        <mat-error *ngIf="error">
          {{ error }}
        </mat-error>
        <p></p>
        <div class="row justify-content-between">
          <div class="col">
            <button
              type="submit"
              mat-flat-button
              color="primary"
              [disabled]="isLoginFormInvalid() || loading"
              class="controles-container"
              (click)="onLogin()"
            >
              <mat-spinner *ngIf="loading" diameter="20"></mat-spinner>
              <span *ngIf="!loading">Ingresar</span>
            </button>
          </div>
          <div class="col">
            <button
              type="submit"
              mat-flat-button
              color="primary"
              [disabled]="isRegisterFormInvalid() || loadingRegister"
              class="controles-container"
              (click)="register()"
            >
              <mat-spinner *ngIf="loadingRegister" diameter="20"></mat-spinner>
              <span *ngIf="!loadingRegister">¡Registarse!</span>
            </button>
          </div>
        </div>

        <div class="measurement-table">
          <span class="toggle-text" (click)="toggleForgotPassword()">
            <u class="hover-effect">¿Olvidaste tu contraseña?</u>
            <i class="fas fa-chevron-down"></i>
          </span>
        </div>
      </form>
    </div>

    <div *ngIf="showForgotPassword" class="forgot-password-container">
      <h2>Restablecer tu contraseña</h2>
      <form (ngSubmit)="resetPassword()">
        <div class="form-group">
          <label for="email">Ingresa tu correo electrónico</label>
          <input
            type="email"
            id="email"
            [(ngModel)]="email"
            name="email"
            class="form-control"
            required
          />
        </div>
        <br>
        <div class="d-flex align-items-center">
          <mat-icon (click)="toggleForgotPassword()" class="me-2 icon-hover" style="cursor: pointer;">arrow_back</mat-icon>
          <button type="submit" class="btn btn-primary" [disabled]="loading">
            <mat-spinner *ngIf="loading" diameter="20"></mat-spinner>
            <span *ngIf="!loading">{{ loading ? '' : 'Enviar enlace al correo' }}</span>
          </button>
        </div>
      </form>
      <div *ngIf="message" class="alert alert-info mt-3">{{ message }}</div>
    </div>
  </div>
</div>